<template>
    <div>
        <div style="margin-top: 15px">
            <el-row :gutter="12">
                <el-col :span="8">
                    <el-button type="primary" style="margin-left: 3px;" icon="el-icon-plus" @click="create()">创建</el-button>
                </el-col>
                <el-col :span="16">
                    <div style="text-align: right;">
                        <el-select style="width: 130px;" v-model="selectValue" placeholder="请选择">
                            <el-option value="1" label="团队名称"></el-option>
                        </el-select>
                        <el-input type="text" style="width:255px;margin-left: 3px;" v-model="queryValue" placeholder="请输入"></el-input>
                        <el-button type="primary" style="margin-left: 3px;" icon="el-icon-search" @click="getTableData">搜索</el-button>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div style="margin-top: 15px;">
            <el-table ref="multipleTable"
                      :data="tableData"
                      style="width: 100%"
                      element-loading-text="数据正在加载中"
                      :header-cell-style="headClass"
                      :row-style="rowClass">
                <!-- <el-table-column type="selection" width="60"></el-table-column> -->
                <el-table-column prop="id" label="ID"></el-table-column>
                <el-table-column label="团队名称" prop="name"></el-table-column>
                <el-table-column label="创建日期" prop="posttime" :formatter="dateFormat"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <button @click="del(scope.row.id)">删除</button>
                        <button @click="update(scope.row)">修改</button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background
                           style="text-align:right;margin-top: 15px;margin-bottom: 65px;"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="condition.pageId"
                           :page-sizes="[10, 50, 100, 200]"
                           :page-size="condition.size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </div>

    </div>
</template>

<script>
    import axios from 'axios'
    import {
        request
    } from '@/utils/request';
    export default {
        name: "waterFilter.vue",
        data() {
            return {
                tableData: [],
                condition: {
                    pageId: 1,
                    size: 10
                },
                total: 0,
                selectValue: '',
                queryValue: '',
                salesTeam: {}
            }
        },
        mounted() {
            this.getTableData();
        },
        methods: {
            handleSizeChange(val) {
                this.condition.size = val;
                this.getTableData();
            },
            handleCurrentChange(val) {
                this.condition.pageId = val;
                this.getTableData();
            },
            headClass({
                row,
                rowIndex
            }) {
                if (rowIndex == 0) {
                    return ''
                }
                return ''
            },
            rowClass({
                row,
                rowIndex
            }) {
                if (rowIndex % 2 == 0) {
                    return 'background:#F1F2F7;'
                } else {
                    return 'background:white;'
                }
                return ''
            },
            create() {
                this.$prompt('请输入团队名称', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(({
                    value
                }) => {
                    request({
                        url: '/SalesTeam/add.do',
                        method: 'get',
                        params: {
                            name: value
                        }
                    }).then(res => {
                        if (res.data) {
                            this.$message.success('操作成功');
                            this.getTableData();
                        } else {
                            this.$message.error("操作失败：" + res.data);
                        }
                    });
                }).catch(() => {

                });
            },
            del(id) {
                this.$confirm('是否确定删除该团队?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    request({
                        url: '/SalesTeam/delete.do',
                        method: 'get',
                        params: {
                            id
                        }
                    }).then(res => {
                        if (res.data) {
                            this.$message.success('操作成功');
                            this.getTableData();
                        } else {
                            this.$message.error("操作失败");
                        }
                    });
                }).catch(() => {

                });
            },
            update(row) {
                this.$prompt('请输入团队新名称', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(({
                    value
                }) => {
                    request({
                        url: '/SalesTeam/update.do',
                        method: 'get',
                        params: {
                            id:row.id,
                            name: value
                        }
                    }).then(res => {
                        if (res.data) {
                            this.$message.success('操作成功');
                            this.getTableData();
                        } else {
                            this.$message.error("操作失败：" + res.data);
                        }
                    });
                }).catch(() => {

                });
            },
            getTableData() {
                let params = {
                    pageId: this.condition.pageId,
                    size: this.condition.size
                }
                if (this.selectValue != '') {
                    if (this.selectValue == '1') {
                        params.name = this.queryValue
                    }
                }
                var thiz = this;
                const loading = this.$loading({
                    lock: true,
                    text: '获取表格数据中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                setTimeout(() => {
                    loading.close();
                }, 3000);
                axios.get(this.$store.getters.getApiValue + '/SalesTeam/list.do', {
                    params: params
                }).then(function(response) {
                    loading.close();
                    var data = response.data;
                    if (data.status == "200") {
                        thiz.total = data.totalCount;
                        thiz.tableData = data.data;
                    } else {
                        thiz.$message.error(data.message);
                    }
                }).catch(function(error) {
                    loading.close();
                    thiz.$message.error("系统异常，请与管理员联系!");
                    console.log(error);
                });
            },

            dateFormat(row, column, cellValue, index) {
                var str = cellValue;
                if (str == null || str == "") {
                    return "";
                } else {
                    return this.getStandardDate(new Date(str));
                }
            },
            getStandardDate(val) {
                var year = val.getFullYear();
                var month = val.getMonth() + 1;
                var day = val.getDate();
                month = month < 10 ? "0" + month : month;
                day = day < 10 ? "0" + day : day;
                return year + "-" + month + "-" + day;
            },
        }
    }
</script>

<style scoped>
    .detail-image {
        width: 120px;
        height: 120px;
    }
</style>